// extracted by mini-css-extract-plugin
export var container = "_bb-1";
export var cornerButtonContainer = "_bb-5";
export var disabled = "_bb-2";
export var fileContainer = "_bb-4";
export var hiddenInput = "_bb-3";
export var widthContainer = "_bb-0";